import { useTranslate } from "react-polyglot";
import { Typography } from "@material-ui/core";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import YellowButton from "../../../SharedComponents/YellowButton.jsx";
import { useBaseData } from "../../../Providers/Data/BaseDataProvider.jsx";
import OrangeSecondButton from "../../../SharedComponents/OrangeSecondButton.jsx";
import RedButton from "../../../SharedComponents/RedButton.jsx";
import useCompanyPublicId from "../../../hooks/useCompanyPublicId";
import { usePayment } from "../../../Providers/Payment/PaymentProvider.jsx";
import { useAuth } from "../../../Providers/Auth/AuthProvider.jsx";

const useStyles = makeStyles(() => ({
  cardBtn: {
    padding: "8px 18px",
    borderRadius: 19,
  },
}));

/* eslint-disable react/prop-types */
/**
 * @param {UserSubscribe} subscribe
 * @param {UserInfo} user
 * @param {Object} rest
 */
const EnableSubscribeButton = ({ subscribe, user, ...rest }) => {
  const t = useTranslate();
  const { enableSubscribe } = useBaseData();

  if (!user) {
    return null;
  }

  return (
    <OrangeSecondButton {...rest} onClick={() => enableSubscribe(subscribe.id)}>
      {t("enable")}
    </OrangeSecondButton>
  );
};

/* eslint-disable react/prop-types */
/**
 * @param {UserSubscribe} subscribe
 * @param {UserInfo} user
 * @param {Object} rest
 */
const StopSubscribeButton = ({ subscribe, user, ...rest }) => {
  const t = useTranslate();
  const { stopSubscribe } = useBaseData();

  if (!user) {
    return null;
  }

  return (
    <RedButton {...rest} onClick={() => stopSubscribe(subscribe.id)}>
      {t("stopSubscribe")}
    </RedButton>
  );
};

/** */
const every = (every) => {
  switch (every) {
    case 1:
      return "onePerMonth";
    case 6:
      return "semiannually";
    case 12:
      return "onceAYear";
  }
};

/**
 * @param {Offer} offer
 * @param {boolean} isOfferRepeat
 * @param {UserOffer} userOffer
 * @param {UserSubscribe} userSubscribe
 * @param {string} promoCode
 * @return {*}
 * @constructor
 */
const BuyOrSubscribeButton = ({ offer, isOfferRepeat, userOffer, userSubscribe, promoCode }) => {
  const classes = useStyles();
  const t = useTranslate();
  const history = useHistory();
  const { setPreselectedOffer, setPreselectedSubject } = useBaseData();
  const { companyName } = useCompanyPublicId();
  const { user } = useAuth();

  const { pay } = usePayment();

  /** */
  const payOrSet = (offer) => {
    if (!user) {
      setPreselectedOffer(offer.id);
      setPreselectedSubject(offer.subjectId);

      history.push(`${companyName ? "/" + companyName : ""}/auth`);
    } else {
      pay(offer.id, promoCode || "");
    }
  };

  if (!offer.isSubscribe) {
    return (
      <YellowButton
        disabled={userOffer?.paid && !isOfferRepeat}
        className={classes.cardBtn}
        onClick={() => payOrSet(offer)}
      >
        <Typography>{userOffer && userOffer.status === "pending" ? t("proceed") : t("buyOffer")}</Typography>
      </YellowButton>
    );
  } else {
    if (userSubscribe && userSubscribe.status === "approved") {
      return <StopSubscribeButton className={classes.cardBtn} subscribe={userSubscribe} user={user} />;
    } else if (userSubscribe && userSubscribe.status === "stopped") {
      return <EnableSubscribeButton className={classes.cardBtn} subscribe={userSubscribe} user={user} />;
    } else {
      return (
        <YellowButton className={classes.cardBtn}>
          <Typography>{t(every(offer.subscribe.every))}</Typography>
        </YellowButton>
      );
    }
  }
};

export default BuyOrSubscribeButton;
